/* eslint-disable max-len */
import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { zeroStates } from '@lyearn-team/content-processing-library';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import shortId from 'shortid';
import findIndex from 'lodash/findIndex';
import $j from 'jquery';
import Radium from 'radium';
import { withRouter } from 'react-router-dom';
import AssetTypeEnum from 'appConsts/AssetType';
import * as DataService from 'helper/LearningSpaceServices/DataService';
import * as LocalStoreService from 'helper/LearningSpaceServices/LocalStore';
import transformChannel from '../../utils/transformChannel';
import mutationSync from 'graphql/helpers/mutationSync';
import PropTypes from 'prop-types';
// import GoBackTopBar from 'learner/components/GoBackTopBar';
import Header from '../Header';
import NavigationFooter from '../NavigationFooter';
import * as TinyPubSub from '../../../../../helper/TinyPubSub';
import CardPopupItemDark from './CardPopupItemDark';
import User from '../../../../../helper/currentUser';
import { channelRoot } from './styles';
import { hideIntercomWidget } from '../../../../../components/IntercomInit/hideShowWidget';

const user = new User();
const INCREMENT_ACCESS_COUNT = 'INCREMENT_ACCESS_COUNT';
const ADD_TIME = 'ADD_TIME';

@Radium
class ChannelCardPopupDark extends Component {
  lastTimeSpentSentTime = null;
  timeSpentInterval = null;

  styles = {
    buttonsWrapper: {
      position: 'absolute',
      top: '50%',
      left: '0px',
      marginTop: '-45px',
      height: '90px',
      width: '100%',
      padding: '0px 24px',
      boxSizing: 'border-box',
      zIndex: 1
    },
    buttons: {
      cursor: 'pointer',
      background: 'rgba(0, 0, 0, 0.92)',
      width: '60px',
      height: '90px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    prevBtn: {
      float: 'left'
    },
    nextBtn: {
      float: 'right'
    }
  };

  static contextTypes = {
    showNavigation: PropTypes.func
  };

  static childContextTypes = {
    nextPressed: PropTypes.func,
    prevPressed: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = { loadingData: false, selectedCardChannel: null };
    if (window.self !== window.top) {
      window.parent.hideIframeLoader();
    }
  }

  getChildContext() {
    return {
      nextPressed: this.nextPressed,
      prevPressed: this.prevPressed
    };
  }

  async componentDidMount() {
    this.showHideIntercom(true);
    this.context.showNavigation && this.context.showNavigation(false);
    this.timeSpentInterval = setInterval(this.doTimeSpentMutation, 10000);
    this.lastTimeSpentSentTime = new Date().getTime();
    this.doIncrementViewCountMutation(this.props.match.params.cardId);
    TinyPubSub.subscribe('windowEscKeyPressed', this.closePopup);
    TinyPubSub.subscribe('windowRightKeyPressed', this.nextPressed);
    TinyPubSub.subscribe('windowLeftKeyPressed', this.prevPressed);
    const channels = this.props.completeLibrary;
    const { isPreview } = this.props;
    const { channelId } = this.props.match.params;
    if (this.props.rootQ && !isPreview) {
      this.setState({ loadingData: true });
      const selectedCardChannel = channels.filter(channel => channel.pid === channelId)[0];

      if (!selectedCardChannel) {
        let channelData;
        channelData = await DataService.fetchChannelLocally(channelId, user.id());
        if (
          channelData &&
          channelData.channel &&
          channelData.channel.length &&
          channelData.channel[0]
        ) {
          try {
            const transformedData = transformChannel(channelData, true);
            this.setState({ selectedCardChannel: transformedData[0], loadingData: false });
          } catch (error) {
            console.log(error);
          }
        }

        channelData = await DataService.fetchChannelRemotely(channelId, user.id());

        try {
          const transformedData = transformChannel(channelData);
          this.setState({ selectedCardChannel: transformedData[0], loadingData: false });
        } catch (error) {
          SnackBarHelper.showSnackbar({
            darkTheme: true,
            label: 'This channel does not exists or has been deleted. Please contact your admin',
            status: 'info'
          });
          window.location.href = '/#/learner/channels/';
          return null;
        }
      } else {
        this.setState({ selectedCardChannel, loadingData: false });
      }
    }
  }

  async componentDidUpdate(prevProps) {
    this.showHideIntercom(true);
    if (this.props.match.params.cardId !== prevProps.match.params.cardId) {
      const currentTime = new Date().getTime();
      if (currentTime - this.lastTimeSpentSentTime > 2000) {
        clearInterval(this.timeSpentInterval);
        await this.doTimeSpentMutation(
          prevProps.match.params.cardId,
          (currentTime - this.lastTimeSpentSentTime) / 1000
        );
        this.timeSpentInterval = setInterval(this.doTimeSpentMutation, 10000);
      } else {
        clearInterval(this.timeSpentInterval);
        this.timeSpentInterval = setInterval(this.doTimeSpentMutation, 10000);
      }
      this.doIncrementViewCountMutation(this.props.match.params.cardId);
    }
  }

  async componentWillUnmount() {
    this.context.showNavigation && this.context.showNavigation(true);
    const currentTime = new Date().getTime();
    if (currentTime - this.lastTimeSpentSentTime > 2000) {
      clearInterval(this.timeSpentInterval);
      await this.doTimeSpentMutation(
        this.props.match.params.cardId,
        (currentTime - this.lastTimeSpentSentTime) / 1000
      );
      this.timeSpentInterval = setInterval(this.doTimeSpentMutation, 10000);
    }
    clearInterval(this.timeSpentInterval);
    TinyPubSub.unsubscribe('windowEscKeyPressed', this.closePopup);
    TinyPubSub.unsubscribe('windowRightKeyPressed', this.nextPressed);
    TinyPubSub.unsubscribe('windowLeftKeyPressed', this.prevPressed);
    this.showHideIntercom(false);
  }

  getFooterProps = () => {
    console.log(this.props);
    const onLastCard = this.currentCardIndex === this.channelCardFeed.length - 1;
    const onFirstCard = this.currentCardIndex === 0;
    let { completeLibrary } = this.props;
    completeLibrary = [...completeLibrary, this.state.selectedCardChannel];
    const currentChannelId = this.state.selectedCardChannel.pid;
    const currentChannel = completeLibrary.find(
      currentLibrary => currentLibrary.pid === currentChannelId
    );
    const currentCardIndex = this.currentCardIndex;
    const previousChannel = currentChannel.approvedChannelCards[currentCardIndex - 1];
    const nextChannel = currentChannel.approvedChannelCards[currentCardIndex + 1];

    const previousChannelText = previousChannel ? previousChannel.name : '';
    const nextChannelText = nextChannel ? nextChannel.name : '';

    const footerProps = {
      previous: {
        label: 'Previous Post',
        title: previousChannelText,
        onClick: () => this.prevPressed(true),
        hidden: onFirstCard,
        link: onFirstCard
          ? ''
          : `/#/learner/channels/${this.props.match.params.channelId}/card/${this.channelCardFeed[currentCardIndex - 1].pid}/${this.props.match.params.type}`
      },
      next: {
        label: 'Next Post',
        title: nextChannelText,
        onClick: () => this.nextPressed(true),
        hidden: onLastCard,
        link: onLastCard
          ? ''
          : `/#/learner/channels/${this.props.match.params.channelId}/card/${this.channelCardFeed[currentCardIndex + 1].pid}/${this.props.match.params.type}`
      }
    };
    return footerProps;
  };

  showHideIntercom(show) {
    setTimeout(() => {
      window.innerWidth < 767 && hideIntercomWidget(show);
    }, 800);
  }

  @autobind
  async doTimeSpentMutation(channelCardId = this.props.match.params.cardId, timeSpent = 10) {
    if (window.isActive && !this.props.isPreview) {
      const channelId = this.props.match.params.channelId;
      const currentUser = {
        userId: user.id(),
        companyId: user.companyId()
      };
      const command = {
        id: shortId(),
        type: ADD_TIME,
        contentId: channelCardId,
        userId: currentUser.userId,
        rootContentId: channelId,
        creatorId: currentUser.userId,
        timeSpent: Math.round(timeSpent),
        timeStamp: new Date().toISOString(),
        companyId: user.companyId()
      };
      await mutationSync({
        offerId: channelCardId,
        offerType: AssetTypeEnum.channel,
        userObject: currentUser,
        command
      });
      this.lastTimeSpentSentTime = new Date().getTime();
    }
  }

  async doIncrementViewCountMutation(channelCardId) {
    if (this.props.isPreview) {
      return;
    }
    const channelId = this.props.match.params.channelId;
    const currentUser = {
      userId: user.id(),
      companyId: user.companyId()
    };
    const [channelCardOffer, channelCardState] = await Promise.all([
      DataService.fetchLatestOfferFromCloudfront(channelCardId),
      DataService.fetchChannelCardState(channelCardId, currentUser.userId, channelId)
    ]);
    if (!channelCardState[0]) {
      const states = zeroStates(channelCardOffer, currentUser);
      await LocalStoreService.saveStates(DataService.formatChannelCardStates(states));
    }
    const command = {
      id: shortId(),
      type: INCREMENT_ACCESS_COUNT,
      contentId: channelCardId,
      rootContentId: channelId,
      userId: user.id(),
      creatorId: user.id(),
      timeStamp: new Date().toISOString(),
      companyId: user.companyId()
    };
    await mutationSync({
      offerId: channelCardId,
      offerType: AssetTypeEnum.channel,
      userObject: currentUser,
      command
    });
  }

  @autobind
  nextPressed(fromSideArrowButtons) {
    if ($j('#_channelVideoCardVideoContainer_ video').length > 0 && fromSideArrowButtons !== true) {
      const stop = this.captureKeyPressForVideo('ArrowRight');
      if (stop) return false;
    }
    const currentCardIndex = findIndex(
      this.channelCardFeed,
      card => card.pid === this.props.match.params.cardId
    );
    if (currentCardIndex < this.channelCardFeed.length - 1) {
      window.location.href =
        '/#/learner/channels/' +
        this.props.match.params.channelId +
        '/card/' +
        this.channelCardFeed[currentCardIndex + 1].pid +
        '/' +
        this.props.match.params.type;
    }
  }

  @autobind
  prevPressed(fromSideArrowButtons) {
    if ($j('#_channelVideoCardVideoContainer_ video').length > 0 && fromSideArrowButtons !== true) {
      const stop = this.captureKeyPressForVideo('ArrowLeft');
      if (stop) return false;
    }

    const currentCardIndex = findIndex(
      this.channelCardFeed,
      edge => edge.pid === this.props.match.params.cardId
    );

    if (currentCardIndex > 0) {
      window.location.href =
        '/#/learner/channels/' +
        this.props.match.params.channelId +
        '/card/' +
        this.channelCardFeed[currentCardIndex - 1].pid +
        '/' +
        this.props.match.params.type;
    }
  }

  captureKeyPressForVideo(pressedKey) {
    if (
      /* !$j(document.activeElement).is('#_channelVideoCardVideoContainer_') || */
      ($j('#_channelVideoCardVideoContainer_ video')[0].ended && pressedKey === 'ArrowRight') ||
      ($j('#_channelVideoCardVideoContainer_ video')[0].currentTime < 2 &&
        pressedKey === 'ArrowLeft')
    ) {
      return false;
    }
    $j('#_channelVideoCardVideoContainer_ video')[0].currentTime =
      pressedKey === 'ArrowRight'
        ? $j('#_channelVideoCardVideoContainer_ video')[0].currentTime + 10
        : $j('#_channelVideoCardVideoContainer_ video')[0].currentTime - 10;
    return true;
  }

  @autobind
  closePopup() {
    if (this.props.isPreview) {
      return;
    }
    window.location.href = '/#/learner/channels/';
  }

  @autobind
  renderCard(loadingData) {
    if (!this.channelCard || loadingData)
      return <div style={{ color: '#fff', fontSize: '18px', textAlign: 'center' }}>Loading...</div>;
    return (
      <CardPopupItemDark
        rootQ={this.channelCard}
        channelName={this.state.selectedCardChannel.name}
        userId={user.id()}
        userObj={this.props.rootQ}
        params={this.props.match.params}
        isPreview={this.props.isPreview}
      />
    );
  }

  render() {
    const { isPreview } = this.props;
    if (!this.props.rootQ && !isPreview) return null;
    const { channelId } = this.props.match.params;
    if (this.props.rootQ && !isPreview && this.state.selectedCardChannel) {
      this.channelCardFeed = [];
      this.state.selectedCardChannel.approvedChannelCards.map(card =>
        this.channelCardFeed.push(card)
      );
      this.currentCardIndex = findIndex(
        this.channelCardFeed,
        edge => edge.pid === this.props.match.params.cardId
      );

      this.channelCard = this.state.selectedCardChannel.approvedChannelCards.filter(
        card => card.pid === this.props.match.params.cardId
      )[0];
      this.state.loadingData = false;
    }

    if (isPreview) {
      this.channelCard =
        this.props.completeLibrary && this.props.completeLibrary.length
          ? this.props.completeLibrary[0].approvedChannelCards[0]
          : {};
      this.state.selectedCardChannel = this.channelCard;
      this.state.loadingData = false;
    }

    const loadingState =
      this.props.loadingData || this.state.loadingData || !this.state.selectedCardChannel;
    const isDarkTheme = isPreview || this.props.match.params.type === 'dark';

    const footerProps = !isPreview && !loadingState && this.getFooterProps();
    return (
      <div className={channelRoot(isDarkTheme)}>
        <div className="channel-content">
          {!isPreview && (
            <Header
              link={`/learner/channels/${channelId}`}
              title={loadingState ? '...' : this.state.selectedCardChannel.name}
            />
          )}
          <div className="channel-card-content">
            {loadingState || !this.channelCard ? this.renderCard(true) : this.renderCard()}
          </div>
          {!isPreview && !loadingState && <NavigationFooter {...footerProps} />}
        </div>
      </div>
    );
  }
}

export default withRouter(ChannelCardPopupDark);
